import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const klaviyoTemplateSchema = z.object({
  id: z.string(),
  name: z.string(),
  hasMalomoLinks: z.boolean(),
  malomoLinkCount: z.number(),
  malomoLinks: z.array(z.string()),
});

export const scanKlaviyoTemplatesForMalomoLinks = {
  name: "scanKlaviyoTemplatesForMalomoLinks" as const,
  input: z.object({
    teamId: zExt.objectId(),
    startScan: z.boolean().optional(),
  }),
  output: z.object({
    scanned: z.boolean(),
    templateCount: z.number(),
    templatesWithMalomoLinks: z.number(),
    templates: z.array(klaviyoTemplateSchema),
  }),
};
